bam-finance-widget {
  
  &.finance-widget {
    position: relative;
    display: block;

    @include desktop() {
      margin-top: -12rem;
    }
  }

  .finance-widget__card {
    height:370px; 
    padding: 0 !important;

    @include tablet() {
      height:390px; 
      padding: 1rem;
    }

    iframe {
      border-radius: 12px;
      padding: 1rem;

      @include tablet() {
        padding: 1.5rem;
      }
    }
  }
}